import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { theme } from "shared/lib/styles";

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColumnContainer = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;

  ${SectionContainer}:first-child {
    margin-block-end: 28px;
  }
`;

export const SectionLabel = styled.h3`
  margin-block-end: 12px;

  color: #000000;
  font-weight: 700;
  font-size: 14px;
`;
export const List = styled.ul``;

export const Item = styled.li`
  &:not(:last-child) {
    margin-block-end: 17px;
  }
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-block-end: 1px solid #000000;

  margin-block-end: 12px;
  padding-block-end: 24px;

  ${theme.breakpoints.only("mobile")} {
    position: relative;

    gap: 0 20px;
    &::after {
      position: absolute;
      inset-block-start: 50%;
      inset-inline-start: 0;
      content: "";

      inline-size: 100%;
      block-size: 1px;

      background-color: rgba(0, 0, 0, 0.2);

      transform: translateY(-50%);
    }

    ${ColumnContainer} {
      &:first-child,
      &:nth-child(3) {
        margin-block-end: 24px;
        padding-block-end: 24px;
      }

      &:nth-child(1) {
        order: 1;

        text-align: end;
      }
      &:nth-child(2) {
        order: 3;

        text-align: end;
      }
      &:nth-child(3) {
        order: 2;
      }
      &:nth-child(4) {
        order: 4;
      }
    }
  }

  ${theme.breakpoints.up("tablet")} {
    grid-template-columns: max-content max-content max-content max-content;
    justify-content: space-between;

    margin-block-end: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    display: flex;
    flex: 0.7 1 0;
    justify-content: flex-start;
    align-items: flex-start;

    inline-size: auto;
    min-block-size: 0;
    margin-block-end: 0;
    border-block-end: none;
    border-inline-end: 1px solid #000000;
  }
`;

export const StyledBaseLink = styled(BaseLink)`
  color: #000000;
  font-weight: 400;
  font-size: 14px;
`;
